import { render, staticRenderFns } from "./banner_right.vue?vue&type=template&id=f5d5fef6&scoped=true"
import script from "./banner_right.vue?vue&type=script&lang=js"
export * from "./banner_right.vue?vue&type=script&lang=js"
import style0 from "./banner_right.vue?vue&type=style&index=0&id=f5d5fef6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d5fef6",
  null
  
)

export default component.exports